module.exports = __webpack_public_path__ + "img/rose_on.10145417.svg";